import script from "./QModalDisconnectCounterparty.vue?vue&type=script&setup=true&lang=js"
export * from "./QModalDisconnectCounterparty.vue?vue&type=script&setup=true&lang=js"

import "./QModalDisconnectCounterparty.vue?vue&type=style&index=0&id=6985b103&scoped=true&lang=scss"

import exportComponent from "/home/signal-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6985b103"]])

export default __exports__